import { render, staticRenderFns } from "./MainMarketApps.vue?vue&type=template&id=8a1afeca&scoped=true"
import script from "./MainMarketApps.vue?vue&type=script&lang=js"
export * from "./MainMarketApps.vue?vue&type=script&lang=js"
import style0 from "./MainMarketApps.vue?vue&type=style&index=0&id=8a1afeca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1afeca",
  null
  
)

export default component.exports